"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllowedPaymentMethods = exports.IInvoiceFrozen = exports.IInvoiceInactive = exports.IInvoiceEmailstatus = exports.IInvoiceStatus = void 0;
var IInvoiceStatus;
(function (IInvoiceStatus) {
    IInvoiceStatus["INITIAL_STATUS_OF_INVOICE_BEFORE_ANY_ACTION_IS_TAKEN_PENDING"] = "pending";
    IInvoiceStatus["UPDATED_STATUS_TO_INDICATE_THE_INVOICE_HAS_EXPIRED_CANCELLED"] = "cancelled";
    IInvoiceStatus["_EXPIRED"] = "expired";
    IInvoiceStatus["UPDATED_STATUS_ONCE_THE_INVOICE_IS_VIEWED_BY_THE_CUSTOMER_VIEWED"] = "viewed";
    IInvoiceStatus["UPDATED_STATUS_ONCE_THE_INVOICE_HAS_BEEN_PAID_BY_THE_CUSTOMER_PAID"] = "paid";
    IInvoiceStatus["UPDATED_STATUS_ONCE_THE_INVOICE_HAS_BEEN_CONFIRMED_BY_THE_CUSTOMER_CONFIRMED"] = "confirmed";
    IInvoiceStatus["_REFUNDED"] = "refunded";
    IInvoiceStatus["UPDATED_STATUS_ONCE_THE_INVOICE_HAS_BEEN_REJECTED_BY_THE_CUSTOMER_REJECTED"] = "rejected";
})(IInvoiceStatus = exports.IInvoiceStatus || (exports.IInvoiceStatus = {}));
var IInvoiceEmailstatus;
(function (IInvoiceEmailstatus) {
    IInvoiceEmailstatus["UPDATED_EMAIL_STATUS_TO_INDICATE_THE_INVOICE_IS_READY_TO_BE_SENT_TO_THE_CUSTOMER_SEND"] = "send";
    IInvoiceEmailstatus["UPDATED_EMAIL_STATUS_ONCE_THE_INVOICE_IS_SENT_TO_THE_CUSTOMER_SENT"] = "sent";
})(IInvoiceEmailstatus = exports.IInvoiceEmailstatus || (exports.IInvoiceEmailstatus = {}));
var IInvoiceInactive;
(function (IInvoiceInactive) {
    IInvoiceInactive[IInvoiceInactive["ACTIVE_0"] = 0] = "ACTIVE_0";
    IInvoiceInactive[IInvoiceInactive["INACTIVE_1"] = 1] = "INACTIVE_1";
})(IInvoiceInactive = exports.IInvoiceInactive || (exports.IInvoiceInactive = {}));
var IInvoiceFrozen;
(function (IInvoiceFrozen) {
    IInvoiceFrozen[IInvoiceFrozen["NOT_FROZEN_0"] = 0] = "NOT_FROZEN_0";
    IInvoiceFrozen[IInvoiceFrozen["FROZEN_1"] = 1] = "FROZEN_1";
})(IInvoiceFrozen = exports.IInvoiceFrozen || (exports.IInvoiceFrozen = {}));
var AllowedPaymentMethods;
(function (AllowedPaymentMethods) {
    AllowedPaymentMethods["amex"] = "amex";
    AllowedPaymentMethods["visa"] = "visa";
    AllowedPaymentMethods["masterCard"] = "masterCard";
    AllowedPaymentMethods["diners"] = "diners";
    AllowedPaymentMethods["discover"] = "discover";
    AllowedPaymentMethods["paypal"] = "paypal";
    AllowedPaymentMethods["debit"] = "debit";
    AllowedPaymentMethods["checking"] = "checking";
    AllowedPaymentMethods["savings"] = "savings";
    AllowedPaymentMethods["corpChecking"] = "corpChecking";
    AllowedPaymentMethods["corpSavings"] = "corpSavings";
    AllowedPaymentMethods["gift"] = "gift";
    AllowedPaymentMethods["ebt"] = "ebt";
    AllowedPaymentMethods["wic"] = "wic";
})(AllowedPaymentMethods = exports.AllowedPaymentMethods || (exports.AllowedPaymentMethods = {}));
